import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { UserSettingsRoutingModule } from './user-settings-routing.module';
import { UserSettingsComponent } from './user-settings.component';
import { HomeMainModule } from '../home-main/home-main.module';
import { UseraccountSettingsComponent } from './useraccount-settings/useraccount-settings.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { PlanHistoryComponent } from './plan-history/plan-history.component';
import { PlanHistoryDetailsComponent } from './plan-history-details/plan-history-details.component';
import { NotificationDetailsComponent } from './notification-details/notification-details.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { HgBlogsComponent } from './hg-blogs/hg-blogs.component';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PhoneNumberSeparatorDirective } from './phone-number-separator.directive';
import { MaterialModule } from '../material-module';

@NgModule({
  imports: [
    CommonModule,
    UserSettingsRoutingModule,
    RouterModule,
    HomeMainModule,
    FormsModule,
    NgxSpinnerModule,
    MaterialModule,
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: '#78C000',
      innerStrokeColor: '#C7E596',
      animationDuration: 300,
      space: -10,
      renderOnClick: false,
    }),
  ],
  exports: [UserSettingsComponent],
  declarations: [
    UserSettingsComponent,
    UseraccountSettingsComponent,
    HeaderComponent,
    FooterComponent,
    PlanHistoryComponent,
    PlanHistoryDetailsComponent,
    NotificationDetailsComponent,
    HgBlogsComponent,
    PhoneNumberSeparatorDirective,
  ],
})
export class UserSettingsModule {}
